// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"29fc700947c4e0a19279","713":"ec48175710dec0bf2fc2","883":"e7d6442ce2b6b34b40d2"}[chunkId] + ".js";
};